module.exports = __webpack_public_path__ + "static/media/notificacion_categoria_recordatorios.915a25da.png";